import { IconPlus } from "@synthesis/shared-icons";
import type { UserDto } from "@synthesis/shared-services/auth/user/types";
import { Button, LoadingIndicator } from "@synthesis/shared-ui";

import { cn, uuidv4 } from "@synthesis/shared-utils";

import { FilledRoleItem } from "./filled-role-item";
import { RoleItem } from "./role-item";
import type { RoleAssignmentType, RoleTableProps } from "../list-of-experts-page.lib";

type RoleRight = "СУПЕР" | "АДМИНИСТРИРОВАНИЕ" | "МОДЕРИРОВАНИЕ" | "ПРОСМОТР" | "НЕТ";

const roleName: Record<RoleRight, string> = {
  СУПЕР: "Суперадмин",
  АДМИНИСТРИРОВАНИЕ: "Админ",
  МОДЕРИРОВАНИЕ: "Модератор",
  ПРОСМОТР: "Просмотр",
  НЕТ: "Нет роли",
};

export const RoleTable = ({
  projectId,
  handleAddRole,
  handleDeleteRole,
  selectedRoles,
  handleSelectRole,
  assignedUsersData,
  isAssignedUsersDataLoading,
  isGroupsLoading,
  isArchived,
  isNotRight,
  selectGroupsValues,
}: RoleTableProps) => {
  const getRoleDisplay = (user: UserDto | undefined): string => {
    const foundRole = user?.realmRoles?.find((role) => role.startsWith("ПЛАТФОРМА 3Д"));
    const roleRight = foundRole?.split(" ")[2] as RoleRight | undefined;
    return roleRight ? roleName[roleRight] : "Нет роли";
  };

  return (
    <section>
      <header className="bg-neutrals-99 text-type-minor grid grid-cols-[1fr_1.5fr_1fr_1fr] rounded border-b text-sm font-normal">
        <h2 className="paragraph-sm flex grow border-r px-4 py-4">Организация</h2>
        <h2 className="paragraph-sm flex grow border-r px-4 py-4">Фамилия Имя Отчество</h2>
        <h2 className="paragraph-sm flex grow border-r px-4 py-4">Права</h2>
      </header>
      <main className={cn((!assignedUsersData || selectedRoles.length === 0) && "pb-6")}>
        {!isAssignedUsersDataLoading && !!assignedUsersData ? (
          assignedUsersData.map((userData) => (
            <FilledRoleItem
              projectId={projectId ?? ""}
              key={userData.user.id}
              userData={userData}
              getRoleDisplay={getRoleDisplay}
              isArchived={isArchived}
              isNotRight={isNotRight}
            />
          ))
        ) : (
          <div className="bg-grey-300 flex w-full animate-pulse justify-center rounded bg-opacity-30 py-8">
            <LoadingIndicator />
          </div>
        )}
        {selectedRoles.map((role: RoleAssignmentType) => (
          <RoleItem
            key={role.id}
            id={role.id}
            onSelect={handleSelectRole}
            onDeleteRole={handleDeleteRole}
            isGroupsLoading={isGroupsLoading}
            getRoleDisplay={getRoleDisplay}
            selectGroupsValues={selectGroupsValues}
          />
        ))}
      </main>
      <Button
        disabled={isArchived || isNotRight}
        className="w-full"
        leftIcon={<IconPlus className="size-5" />}
        type="button"
        onClick={() => handleAddRole(uuidv4())}
      >
        Добавить эксперта
      </Button>
    </section>
  );
};
